import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getSendGridDynamicTemplates = async () => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    query: graphql(`
      query GetSendGridDynamicTemplates {
        getSendGridDynamicTemplates {
          id
          name
          htmlContent
        }
      }
    `),
  });

  return response.data.getSendGridDynamicTemplates;
};
